import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { RequestTypes } from '../../../models/enums/request-types.enum';
import { HttpService } from './../http.service';
import { HttpConfiguration } from '../../../app.http.config';

@Injectable()
export class TrialHttpService extends HttpService {
    constructor(httpConfig: HttpConfiguration, http: HttpClient) {
        super('api/trial/', RequestTypes.InternalApi, httpConfig, http);
    }

    public postTrialForm(item: any): Observable<any> {
        return this.post('postTrialForm', item).pipe();
    }

    public facebookLeadActivate(item: any): Observable<any> {
        return this.post('facebookLeadActivate', item).pipe();
    }

    public postTrialActivateByPhone(item: any): Observable<any> {
        return this.post('postTrialActivateByPhone', item).pipe();
    }

    public checkTrialAvailable(): Observable<any> {
        return this.get('checkTrialAvailable', null).pipe();
    }

    public checkTrialCardsAvailable(): Observable<any> {
        return this.get('checkTrialCardsAvailable', null).pipe();
    }

    public changePhoneOnTrial(item: any): Observable<any> {
        return this.post('changePhoneOnTrial', item).pipe();
    }

    public googleTrial(token: string): Observable<any> {
        const body = new HttpParams().set('idtoken', token);
        return this.postUrlEncoded('/google', body.toString()).pipe();
    }

    public autumnPromoPreactivation(): Observable<any> {
        return this.post('autumn-promo-preactivation', null).pipe();
    }

    public autumnPromoActivation(): Observable<any> {
        return this.post('autumn-promo-activation', null).pipe();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/internal/trial.http.service.ts